import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { filterNull } from '@/utils/index'
import { MessageBox } from 'element-ui'
import router from '@/router'
import { getItem } from '@/utils/localStorage'
const version = require('../../../public/version.json')
const service = axios.create({
  baseURL: 'newApi/cloud/edata-user'
})

service.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers['Authorization'] = getToken()
      config.headers['versionCode'] = version.version
    }
    // 动态获取当前机构ID
    const orgInfo = getItem('orgInfo')
    if (orgInfo && orgInfo.organizationId) {
      config.headers['organizationId'] = orgInfo.organizationId
    }
    return config
  },
  (error) => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 调试日志:确认 edata-user 真实响应 code 值
    console.log('[edataUser response]', res.code, res.msg, res.data ? Object.keys(res.data) : null)
    // 成功判断:code === 1 (Result.OK) 或 code === 0 (部分接口)
    if (res.code === 1 || res.code === 0) {
      if (res.records) {
        res.records = filterNull(res.records)
      }
      if (res.data && Object.prototype.toString.call(res.data) === '[object Object]') {
        res.data = filterNull(res.data)
      }
      return res
    }
    // 业务异常:统一直接 return res,由业务代码在 then 里判断 res.code
    // 不再 Promise.reject,避免 reject 时吞掉 res.data(弹窗需要)
    if ([7003, 7005, 7023].includes(res.code)) {
      return res
    }
    if (res.code === 707100 || res.code === 707101 || res.code === 707102) {
      return res
    }
    // token 过期:特殊处理
    if (res.code === 2002 || res.code === 2001 || res.code === 2003) {
      return store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }
    // 6000-7000 范围:提示框
    if (res.code >= 6000 && res.code < 7000) {
      MessageBox.confirm(res.error || res.message || res.msg, '提示', {
        confirmButtonText: '我知道了',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        router.replace({
          path: '/refresh' + window.location.href.split('#')[1]
        })
      })
      return res
    }
    // 未知 code:弹 toast 并 reject
    Message({
      message: res.msg || 'Error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(new Error(res.msg || 'Error'))
  },
  (error) => {
    if (error.message && error.message === 'cancel') {
      return Promise.reject(error)
    }
    console.log('err' + error) // for debug
    if (error.response) {
      const { status, data } = error.response
      if (status !== 200) {
        Message({
          message: data.msg || data.message || '系统错误',
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        Message({
          message: error.msg || '系统错误',
          type: 'error',
          duration: 5 * 1000
        })
      }
    } else {
      Message({
        message: '网络错误',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
